import ScalarIconGear_vue_vue_type_script_setup_true_lang_default from "./ScalarIconGear.vue.script.js";
//#region src/components/ScalarIconGear.vue
var ScalarIconGear_default = ScalarIconGear_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconGear_default as default };

//# sourceMappingURL=ScalarIconGear.js.map